// Ticket Query Keys
export const GET_TICKETS_QUERY_KEY = 'useGetTickets';
export const PENDING_TICKET_SUMMARY_QUERY_KEY = 'useGetPendingTicketSummary';
export const GET_REQUESTOR_PENDING_TICKETS_QUERY_KEY = 'useGetRequestorPendingTickets';

// Ticket Summary Query Keys
export const GET_SUMMARY_LISTS_QUERY_KEY = 'useListTicketSummaryLists';
export const GET_TICKET_SUMMARY_LIST_BY_ID_QUERY_KEY = 'useTicketSummaryListById';
export const GET_TICKET_SUMMARIES_BY_LIST_QUERY_KEY = 'useTicketSummariesByList';
export const CREATE_TICKET_SUMMARY_LIST_KEY = 'useCreateTicketSummaryList';
export const UPDATE_TICKET_SUMMARY_LIST_KEY = 'useUpdateTicketSummaryList';
export const UPDATE_SUMMARY_ANSWERS_KEY = 'useUpdateSummaryAnswers';
export const DELETE_TICKET_SUMMARY_LIST_KEY = 'useDeleteTicketSummaryList';

